export const resellersTypes = Object.freeze({
  SET_RESELLERS: 'SET_RESELLERS',
  SEARCH_RESELLERS: 'SEARCH_RESELLERS',
  SET_CURRENT_RESELLERS: 'SET_CURRENT_RESELLERS',
  SELECT_RESELLER: 'SELECT_RESELLER',
  RESET_SELECTED_RESELLER: 'RESET_SELECTED_RESELLER'
})
